import { useEffect, useState } from 'react';

// Returns an array of products with stock below the threshold
export function useLowStockAlerts(products, enabled, threshold = 5) {
  const [lowStockProducts, setLowStockProducts] = useState([]);

  useEffect(() => {
    if (!enabled) {
      setLowStockProducts([]);
      return;
    }
    if (Array.isArray(products)) {
      setLowStockProducts(products.filter(p => typeof p.stock === 'number' && p.stock <= threshold));
    }
  }, [products, enabled, threshold]);

  return lowStockProducts;
}
